module.exports = __webpack_public_path__ + "static/logo-647a2a74b19aa0bea1e7928770f1520b.svg";